// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"e56bdde6","1157":"fdaa5260","6487":"90482ecb","8008":"c20cdf27","8096":"2f017705","9286":"e95be620"}[chunkId] + ".css";
};